import { Box, Typography } from "@mui/material";

export default function SubtitleBox({
  text,
  secondaryText = "",
  show = true,
  maxRows = 4,
  width = 600,
}) {
  if (!show) return null;

  const lineHeight = 20; // aprox px

  return (
    <Box
      sx={{
        position: "relative",
        bgcolor: "rgba(0,0,0,0.6)",
        px: 2,
        py: 1,
        borderRadius: 2,
        width: { xs: "min(350px, calc(100vw - 32px))", sm: width },
        maxWidth: "calc(100vw - 32px)",
        maxHeight: { xs: "min(230px, 34vh)", sm: maxRows * 24 + 16 },
        overflowY: "auto",
        zIndex: 1,
        mt: { xs: 1.25, sm: 1 },
        mx: "auto",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
        border: "1px solid rgba(255, 255, 255, 0.15)",
        // Scroll personalizado
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(255, 255, 255, 0.3)",
          borderRadius: "3px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.5)",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "transparent"
        }
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: "#fff",
          textAlign: "center",
          whiteSpace: "pre-wrap",
          lineHeight: `${lineHeight}px`
        }}
      >
        {text}
      </Typography>
      {secondaryText && (
        <Typography
          variant="caption"
          sx={{
            color: "rgba(255,255,255,0.88)",
            textAlign: "center",
            display: "block",
            mt: 0.35,
            fontSize: "0.75rem",
            lineHeight: "16px",
          }}
        >
          {secondaryText}
        </Typography>
      )}
    </Box>
  );
}
